import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export interface TextPopupOptions {
	color?: string;
	params?: unknown[];
}

// Generic floating message above a tile, drawn by TextPopupRenderer. See docs/effects.md.
// Carries a localization key (resolved by the renderer via Strings), not literal text, so the
// engine stays localization-agnostic like the HUD/event channels.
export class TextPopupEffect extends XYEffect {
	static key = "TextPopupEffect";

	readonly textKey: string;
	readonly params: unknown[];
	readonly color?: string;

	constructor(xy: XY, textKey: string, opts: TextPopupOptions = {}) {
		super(xy);
		this.textKey = textKey;
		this.params = opts.params ?? [];
		this.color = opts.color;
		this.setUnbounded(true);
	}
}
